import {
  MutationCache,
  matchQuery,
  QueryCache,
  QueryClient,
  type QueryKey,
} from '@tanstack/react-query'
import { PROFILE } from './api/keys'
import { statusOf } from './api/stops'

let bounce: (() => void) | null = null

export const onSessionLost = (handler: () => void) => {
  bounce = handler
}

export const forgetAccount = (client: QueryClient) =>
  client.removeQueries({ predicate: (query) => !matchQuery({ queryKey: PROFILE }, query) })

const sessionLost = (error: unknown) => {
  if (statusOf(error) !== 401) return

  forgetAccount(queryClient)
  queryClient.setQueryData(PROFILE, null)
  bounce?.()
}

export const shouldRetry = (attempts: number, error: unknown): boolean => {
  const status = statusOf(error)

  return status !== undefined && status >= 500 && attempts < 2
}

export const cached = <TOptions extends { queryKey: QueryKey }>(options: TOptions) => ({
  ...options,
  staleTime: 'static' as const,
})

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: sessionLost }),
  mutationCache: new MutationCache({ onError: sessionLost }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
    mutations: { retry: false },
  },
})
